const { Box, Skeleton, Typography, Stack, Avatar } = require('@mui/material')

const MAX_COLUMN = 9
const MAX_LINE = 5

const WIDTH_ELEMENT = '100%'

export function renderColumns() {
  const array = []
  for (let index = 0; index < MAX_COLUMN; index += 1) {
    array.push(index)
  }

  return array.map((item) => {
    const key = `column-${item}`
    return (
      <Stack
        key={key}
        flexDirection="row"
        gap="0.4rem"
        width={WIDTH_ELEMENT}
        alignItems="center"
        justifyContent="flex-start"
      >
        <Skeleton variant="circular" width="0.8rem" height="0.8rem">
          <Avatar />
        </Skeleton>
        <Skeleton width="100%">
          <Typography>.</Typography>
        </Skeleton>
      </Stack>
    )
  })
}

export function renderCels(columnsLength = MAX_COLUMN) {
  const array = []
  for (let index = 0; index < columnsLength; index += 1) {
    array.push(index)
  }
  return array.map((item) => {
    const key = `line-${item}`
    return (
      <Stack
        key={key}
        flexDirection="row"
        gap="0.5rem"
        width={WIDTH_ELEMENT}
        alignItems="center"
        justifyContent="center"
      >
        <Skeleton variant="rectangular" height="1rem" width="100%">
          <Typography>.</Typography>
        </Skeleton>
      </Stack>
    )
  })
}

export function renderLines({ columnsLength = MAX_COLUMN, rowsLength = MAX_LINE }) {
  const array = []
  for (let index = 0; index < rowsLength; index += 1) {
    array.push(index)
  }

  return array.map((item) => {
    const key = `line-${item}`
    return (
      <Box
        key={key}
        display="flex"
        flexDirection="row"
        borderBottom={2}
        borderColor="divider"
        gap="0.5rem"
        height="2rem"
        flexWrap="nowrap"
      >
        {renderCels(columnsLength)}
      </Box>
    )
  })
}
